import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { StandingsResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A group-play draw's PUBLIC standings (GET /tournaments/draws/{id}/standings
 * → StandingsResponse, anonymous-readable). Its OWN query, fetched ONLY when a
 * round-robin or group-to-knockout draw is selected (the component is mounted
 * conditionally), so the standings fetch never fires for a single-elimination
 * draw. The page renders
 * the server's rows / ranks / diffs VERBATIM — no client-side ranking, sorting,
 * or diff arithmetic.
 */
export function useDrawStandings(drawId: string | undefined) {
  return useQuery<StandingsResponse>({
    queryKey: queryKeys.tournaments.standings(drawId ?? ""),
    queryFn: () => tournamentApi.getStandings(drawId as string),
    enabled: Boolean(drawId),
  });
}
